export default function ({ store, redirect }) {
  if (!store.getters.currentOrder) {
    return redirect('/menu/pizzas')
  }
}
